import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { ArrowLeft, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function NewsDetailPage() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    setItem(null);
    setError("");
    fetch(`${API}/api/news/${slug}`)
      .then(async (r) => {
        if (!r.ok) throw new Error("Notizia non trovata.");
        return r.json();
      })
      .then(setItem)
      .catch((e) => setError(e.message));
  }, [slug]);

  if (error) {
    return (
      <Layout>
        <div className="max-w-3xl mx-auto px-6 py-24 text-center">
          <p className="text-[#C15C3D] font-semibold mb-5">{error}</p>
          <Link to="/news" className="inline-flex items-center gap-2 text-[#2E4F3B] font-bold underline">
            <ArrowLeft className="w-4 h-4" />
            Torna alle notizie
          </Link>
        </div>
      </Layout>
    );
  }

  if (!item) {
    return (
      <Layout>
        <div className="max-w-3xl mx-auto px-6 py-24 flex items-center justify-center text-[#5C5C5C]">
          <Loader2 className="w-5 h-5 animate-spin mr-2" />
          Caricamento…
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <article data-testid="news-detail" className="bg-[#FBF9F6]">
        {item.image_url && (
          <div className="aspect-[16/7] overflow-hidden bg-[#1f2d22]">
            <img src={item.image_url} alt={item.title} className="w-full h-full object-cover" />
          </div>
        )}
        <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 py-14 sm:py-20">
          <Link to="/news" data-testid="news-back" className="inline-flex items-center gap-2 text-sm text-[#5C5C5C] hover:text-[#1A1A1A] mb-5">
            <ArrowLeft className="w-4 h-4" />
            Torna alle notizie
          </Link>
          <h1 data-testid="news-detail-title" className="font-display text-3xl sm:text-4xl lg:text-5xl font-black text-[#1A1A1A] leading-tight tracking-tight">
            {item.title}
          </h1>
          {item.author && (
            <div className="mt-5 text-sm text-[#5C5C5C]">
              di <strong className="text-[#1A1A1A]">{item.author}</strong>
            </div>
          )}
          <p className="mt-7 text-lg sm:text-xl text-[#1A1A1A] font-semibold leading-snug italic">
            {item.excerpt}
          </p>
          <div className="mt-9 text-base sm:text-lg text-[#3F3F3F] leading-relaxed whitespace-pre-line">
            {item.content}
          </div>
        </div>
      </article>
    </Layout>
  );
}
